const CoverSectionController = require('./VideoCoverSectionController');
const DetailsSectionController = require('./DetailsSectionController');
const DefaultSectionController = require('./DefaultSectionController');

module.exports.createController = (name, el) => {
    let obj = null;
    switch (name) {
        case 'cover':
            obj = CoverSectionController(el, name);
            break;

        case 'review':
        case 'fix':
            obj = DetailsSectionController(el, name);
            break;

        case 'config':
            obj = DefaultSectionController(el, name);
            break;
    }
    return obj;
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/SectionControllerFactory.js